/**
 * Business unit names and codes
 */

const ENUMS_BUSINESS_UNITS = {
  SMM: {
    name: "Social Media Management",
    nameWrap: "Social Media <br>Management",
    home: "/social-media-scheduler/",
    cta: {
      text: "Get started",
      link: "https://app.later.com/user/signup/",
    },
    defaultPreviewImage: "/images/homepage/later-meta-image.jpg",
    helpCenterLink: "https://help.later.com/",
  },
  IM: {
    name: "Influencer Marketing",
    nameWrap: "Influencer <br>Marketing",
    home: "/influencer-marketing-platform/",
    cta: {
      text: "Get started",
      link: "https://later.com/try/influencer-marketing-demo/",
    },
    defaultPreviewImage: "/images/homepage/later-meta-image.jpg",
    helpCenterLink: "https://help-influence.later.com/",
  },
  LIB: {
    name: "Link in Bio",
    nameWrap: "Link in Bio",
    home: "/link-in-bio/",
    cta: {
      text: "Claim your free Link in Bio",
      link: "https://app.later.com/user/signup/?feature_source=linkin.bio",
    },
    defaultPreviewImage: "/images/homepage/later-meta-image.jpg",
    helpCenterLink: "https://help.later.com/",
  },
};

/**
 * Function - Accepts a businessUnitName and returns the key used in ENUMS_BUSINESS_UNITS
 *
 * Use case - Contentful pages use business unit names (e.g. Social Meida Management)
 * and need to be mapped to the key when used in the code.
 *
 * @param {string} businessUnitName - [Social Media Management || Influencer Marketing || Link in Bio]
 *
 * @return {string} - business unit key
 */
const getBusinessUnitKeyFromName = (businessUnitName) => {
  const key = Object.keys(ENUMS_BUSINESS_UNITS).find(
    (unitKey) => ENUMS_BUSINESS_UNITS[unitKey].name === businessUnitName
  );
  return key || "SMM";
};

const ENUMS_BUSINESS_UNITS_ORDERED = ["SMM", "IM", "LIB"];

export {
  ENUMS_BUSINESS_UNITS,
  ENUMS_BUSINESS_UNITS_ORDERED,
  getBusinessUnitKeyFromName,
};
